import { render, staticRenderFns } from "./Groupandcompany.vue?vue&type=template&id=23f946e0&scoped=true&"
import script from "./Groupandcompany.vue?vue&type=script&lang=js&"
export * from "./Groupandcompany.vue?vue&type=script&lang=js&"
import style0 from "./Groupandcompany.vue?vue&type=style&index=0&id=23f946e0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f946e0",
  null
  
)

export default component.exports